// eslint-disable-next-line import/no-cycle
import { PARAMS } from '../API_Utils';
import getResponse from '../API_Utils/APIUtil/ApiClient';
import apiConfig from '../API_Utils/APIUtil/ApiConfig';
import {
  FlatFiltersPostBody,
  getASNClient,
  getGRNClient,
  getInternationalInventoryClient,
  getPOClient,
  getSalesOrderClient,
  getSalesPOClient,
  getSoGRNClient
} from '../clientUtils';

const transformFilters = (data) => {
  const transformed = data?.filter((item) => !['start_date', 'end_date'].includes(item.field));

  // let i = -1;

  // const filterDateOn = transformed.find((field, index) => {
  //   if (field?.field === 'filter_date_on') {
  //     i = index;
  //     return true;
  //   }
  //   return false;
  // });

  // i > -1 && transformed.splice(i, 1);

  const date = {
    field: 'dateRange',
    type: 'dateRange',
    options: [
      { label: 'Last 1 Month', value: 30 },
      { label: 'Last 6 Month', value: 180 },
      { label: 'Year Till Date', value: 365 }
    ]
  };
  transformed?.unshift(date);
  // FIXME: tranform here if needed
  return data;
};

const getList = async (type, selectedFilters, state, pagination, afterFetch, signal) => {
  let res = {};
  const paramsObj = PARAMS.createPOParams(type, selectedFilters, state, pagination);
  const soParamObj = PARAMS.createSOParams(selectedFilters, state, pagination);
  const userParams = PARAMS.userParams(pagination);
  if (['po', 'por'].includes(type)) {
    res = await getPOClient().purchaseOrderList(paramsObj.poParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'po_asn') {
    res = await getASNClient().asnListGet(paramsObj.asnParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'po_grn') {
    res = await getGRNClient().grnListGet(paramsObj.grnParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 's_cpo') {
    res = await getSalesPOClient().v1SiPoListGet(
      soParamObj.salesPurchaseOrderParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 's_dso') {
    res = await getSalesOrderClient().v1SiSoListGet(soParamObj.soParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 's_iso') {
    res = await getSalesOrderClient().v1SiEoListGet(soParamObj.soParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'so_dgrn') {
    res = await getSoGRNClient().v1SiGrnListGet(
      soParamObj.salesGRNParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'so_igrn') {
    res = await getSoGRNClient().v1SiEoGrnListGet(
      soParamObj.salesGRNParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'inventory') {
    res = await getInternationalInventoryClient().internationalInventoryListGet(
      paramsObj.inventoryParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'ro') {
    res = await getResponse(
      apiConfig.returnOrder.list,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
    // res = await getROClient().list(soParamObj.roParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'poReturnOrder') {
    res = await getResponse(
      apiConfig.poReturnOrder.list,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
  }

  if (type === 'users') {
    res = await getResponse(
      apiConfig.userManagement.list,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
  }

  if (type === 'cogs') {
    const f = FlatFiltersPostBody(selectedFilters);
    f.fileUploadType = ['LAST_APPROVED_COGS'];
    if (!selectedFilters?.status || selectedFilters?.status?.length === 0) {
      f.status = ['APPROVAL_PENDING', 'REJECTED', 'APPROVED', 'SUCCESSFUL', 'VALIDATION_FAILED_POST_APPROVAL','APPROVAL_IN_PROGRESS'];
    }
    res = await getResponse(apiConfig.masters.cogs.list, userParams, f, undefined, true);
  }

  if (type === 'transfer_pricing') {
    const f = FlatFiltersPostBody(selectedFilters);
    if (!selectedFilters?.fileUploadType || selectedFilters?.fileUploadType?.length === 0) {
      f.fileUploadType = ['MDM_SKU_TP_CREATE', 'MDM_SKU_TP_UPDATE'];
    }
    if (!selectedFilters?.status || selectedFilters?.status?.length === 0) {
      f.status = ['APPROVAL_PENDING', 'REJECTED', 'APPROVED', 'SUCCESSFUL', 'VALIDATION_FAILED_POST_APPROVAL','APPROVAL_IN_PROGRESS'];
    }
    res = await getResponse(apiConfig.masters.tp.list, userParams, f, undefined, true);
  }

  if (type === 'user_access_review') {
    res = await getResponse(
      apiConfig.userAccessReview.list,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
  }

  afterFetch(res?.data?.data);
  const p = {
    total: res?.headers['x-total-count'],
    current: parseInt(res?.headers['x-current-page'], 10) + 1,
    pageSize: res?.headers['x-page-size']
  };
  return p;
};

const getStatus = async (type, selectedFilters, state, pagination, afterFetch, signal) => {
  let res = {};
  const userParams = PARAMS.userParams(pagination);
  const paramsObj = PARAMS.createPOParams(type, selectedFilters, state, pagination);
  if (['po', 'por'].includes(type)) {
    res = await getPOClient().purchaseOrderSummary(paramsObj.poParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'po_asn') {
    res = await getASNClient().asnSummaryGet(paramsObj.asnParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 'po_grn') {
    res = await getGRNClient().grnSummaryGet(paramsObj.grnParams, signal, FlatFiltersPostBody(selectedFilters));
  }
  if (type === 's_cpo') {
    res = await getSalesPOClient().v1SiPoSummaryGet(
      paramsObj.salesPurchaseOrderParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }

  if (type === 's_dso') {
    res = await getSalesOrderClient().v1SiSoSummaryGet(
      paramsObj.soParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 's_iso') {
    res = await getSalesOrderClient().v1SiEoSummaryGet(
      paramsObj.soParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'so_dgrn') {
    res = await getSoGRNClient().v1SiGrnSummaryGet(
      paramsObj.salesGRNParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'so_igrn') {
    res = await getSoGRNClient().v1SiEoGrnSummaryGet(
      paramsObj.salesGRNParams,
      signal,
      FlatFiltersPostBody(selectedFilters)
    );
  }
  if (type === 'ro') {
    res = await getResponse(
      apiConfig.returnOrder.summary,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
  }
  if (type === 'poReturnOrder') {
    res = await getResponse(
      apiConfig.poReturnOrder.summary,
      userParams,
      FlatFiltersPostBody(selectedFilters),
      undefined,
      true
    );
  }
  afterFetch(res?.data?.data);
};

async function getFilters(type, afterFetch, signal) {
  let res = {};
  if (['po', 'por'].includes(type)) {
    res = await getPOClient().purchaseOrderFiltersGet(type, signal);
  }
  if (type === 'po_grn') {
    res = await getGRNClient().grnFiltersGet(signal);
  }
  if (type === 's_cpo') {
    res = await getSalesPOClient().v1SiPoFiltersGet(signal);
  }
  if (type === 'po_asn') {
    res = await getASNClient().asnFiltersGet(signal);
  }
  if (type === 's_dso') {
    res = await getSalesOrderClient().v1SiSoFiltersGet(signal);
  }
  if (type === 's_iso') {
    res = await getSalesOrderClient().v1SiSoEoFiltersGet(signal);
  }
  if (type === 'so_dgrn') {
    res = await getSoGRNClient().v1SiGrnFiltersGet(signal);
  }
  if (type === 'so_igrn') {
    res = await getSoGRNClient().v1SiEoGrnFiltersGet(signal);
  }
  if (type === 'inventory') {
    res = await getInternationalInventoryClient().internationalInventoryFiltersGet(signal);
  }
  // if (type === 'ro') {
  //   res = await getROClient().getFilters(signal);
  // }
  if (type === 'users') {
    res = await getResponse(apiConfig.userManagement.filters, null, null, null, true);
  }
  if (type === 'ro') {
    res = await getResponse(apiConfig.returnOrder.filters, null, null, null, true);
  }
  if (type === 'poReturnOrder') {
    res = await getResponse(apiConfig.poReturnOrder.filters, null, null, null, true);
  }
  if (type === 'cogs') {
    res = await getResponse(apiConfig.masters.cogs.filters, { view_type: 'COGS' }, null, null, true);
  }

  if (type === 'transfer_pricing') {
    res = await getResponse(apiConfig.masters.tp.filters, { view_type: 'TP' }, null, null, true);
  }
  afterFetch(transformFilters(res?.data?.data));
}

export { getList, getStatus, getFilters };

/**
 *
 * @param {Array} data - {id: 'string', label: 'string'}
 */
// const transformObjectToIds = (data) => {
//   if (!data || data.length === 0) return undefined;
//   const d = data.map((item) => item.id);
//   return d;
// };
